import { Modal, notification } from 'antd';

type Level = 'info' | 'warning' | 'urgent';

/**
 * How team-sent messages surface in the speaker UI:
 * - info    → blue notification top-right, auto-dismisses
 * - warning → orange notification top-right, persists until clicked
 * - urgent  → modal that demands the speaker click OK to acknowledge
 */
export function showTeamMessage(text: string, level: Level): void {
  if (level === 'urgent') {
    Modal.warning({
      title: 'Message from the team',
      content: text,
      okText: 'OK',
      centered: true,
      maskClosable: false,
    });
    return;
  }
  notification.open({
    type: level === 'warning' ? 'warning' : 'info',
    message: 'Message from the team',
    description: text,
    placement: 'topRight',
    duration: level === 'warning' ? 0 : 8,
  });
}
